import { useState, useEffect, useCallback } from 'react';
import { rememberMeUtils } from '../utils/rememberMe';

export const useRememberMe = () => {
  const [isRemembered, setIsRemembered] = useState(false);
  const [savedEmail, setSavedEmail] = useState('');
  const [isStorageAvailable, setIsStorageAvailable] = useState(true);

  // Initialize from localStorage on mount
  useEffect(() => {
    const storageAvailable = rememberMeUtils.isStorageAvailable();
    setIsStorageAvailable(storageAvailable);

    if (storageAvailable) {
      const rememberedState = rememberMeUtils.getRememberMe();
      const email = rememberMeUtils.getSavedEmail();

      setIsRemembered(rememberedState);
      setSavedEmail(email);
    }
  }, []);

  // Save remember me preference and email
  const saveRememberMe = useCallback((email, remember = true) => {
    if (!isStorageAvailable) {return;}

    try {
      rememberMeUtils.saveRememberMe(email, remember);
      setIsRemembered(remember);
      setSavedEmail(remember ? email : '');
    } catch (error) {
      console.warn('Failed to save remember me preference:', error);
    }
  }, [isStorageAvailable]);

  // Clear remember me data
  const clearRememberMe = useCallback(() => {
    if (!isStorageAvailable) {return;}

    try {
      rememberMeUtils.clearRememberMe();
      setIsRemembered(false);
      setSavedEmail('');
    } catch (error) {
      console.warn('Failed to clear remember me data:', error);
    }
  }, [isStorageAvailable]);

  // Toggle remember me state
  const toggleRememberMe = useCallback((email) => {
    const newState = !isRemembered;
    if (newState) {
      saveRememberMe(email, true);
    } else {
      clearRememberMe();
    }
  }, [isRemembered, saveRememberMe, clearRememberMe]);

  return {
    isRemembered,
    savedEmail,
    isStorageAvailable,
    saveRememberMe,
    clearRememberMe,
    toggleRememberMe,

    // Utility functions
    setRememberState: setIsRemembered,
    setSavedEmailState: setSavedEmail
  };
};

export default useRememberMe;
